export default "__VITE_ASSET__zXPqpX3F__"